import {FC, memo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {setShowDialog} from '../../redux/order/ordersSlice'
import AsyncListPage from 'app/components/AsyncListPage'
import ConfirmationDialog from '_core/components/ConfirmationDialog'
import TableCard from '_core/components/TableCard'
import OrderListWithItem from './OrderListWithItem'
import OrderListHeader from './OrderListHeader'
import OrderListFilters from './OrderListFilters'

const pageSize = 10
type Props = {
  title: string
  isFetching: boolean
  filter: any
  orders: any
  showDeleteDialog: boolean
  isSubmitting: boolean
  exportFilter: any
  isHomePage?: boolean
  onOrderBy: (orderBy: string) => void
  onFilterChange: (filter: any) => void
  onCancel: (orderId: string) => void
  onPageChange: (currentPage: number) => void
  totalCount: number
}
const OrderTableWrapper: FC<Props> = ({
  title,
  isFetching,
  showDeleteDialog,
  isSubmitting,
  exportFilter,
  onCancel,
  onPageChange,
  totalCount,
  ...props
}) => {
  const dispatch = useDispatch()

  const paging = useSelector<RootState>(({misc}) => misc.paging) as any
  const [orderId, setOrderId] = useState<string>('')

  const handleOpenDialog = (id: any) => {
    setOrderId(id)
    dispatch(setShowDialog(true))
  }

  const handleCloseDialog = () => {
    dispatch(setShowDialog(false))
  }

  return (
    <AsyncListPage isFetching={isFetching} totalRecords={props.orders?.length}>
      <TableCard
        title={title}
        className='card-xl-stretch mb-5 mb-xl-8'
        toolbar={<OrderListHeader filter={exportFilter} />}
        filter={<OrderListFilters {...props} />}
        paging={{
          ...paging,
          onPageChange,
          pageSize,
          currentPage: props.filter?.currentPage || paging.currentPage,
          isDisableResetPaging: true,
          totalCount: totalCount || paging.totalCount,
        }}
      >
        <OrderListWithItem onDelete={handleOpenDialog} {...props}>
          <ConfirmationDialog
            show={showDeleteDialog}
            title='Cancel order'
            message='Are you sure to Cancel this order?'
            onClose={handleCloseDialog}
            onConfirm={() => onCancel(orderId)}
            isSubmitting={isSubmitting}
          />
        </OrderListWithItem>
      </TableCard>
    </AsyncListPage>
  )
}

export default memo(OrderTableWrapper)
